import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Table, Space,Tooltip } from "antd";
import { Container } from "./Components";
import "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import {nFormatter} from "utils/randomString"

const { Title, Text } = Typography;

const colors= 
[
  "#7DB8AD",
  "#1B6053",
  "#78991A",
  "#0C2924",
  "#327AE7",
  "#E6E7E7",
]

export default function HSCodeDistribution({ data,hsCodes,flatArray }) {
  const [allData, setAllData] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [tableData, setTableData] = useState([]);
 
  const columns = [
    {
      title: "HS Code",
      dataIndex: "hs_code",
      key: "hs_code",
      render: (text, record) => {
        return (
         
           <Tooltip title={hsCodes?.[text?.hs_code]}>
              <Space>
           <span
              style={{
                height: 14,
                width: 14,
                borderRadius: 2,
                background: text?.color,
                display: "block",
              }}
            ></span>
            <Text>{text?.hs_code}</Text>
            </Space>
           </Tooltip>
           
         
        );
      },
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
    },
  ];

  useEffect(() => {
    if (flatArray ) {
           // Create items array
var items = Object.keys(flatArray).map(function(key) {
  return {[key]:flatArray[key]};
});

// Sort the array based on the second element
items.sort(function(first, second) {
  return Object.values(second)?.[0] - Object.values(first)?.[0];
});

// Create a new array with only the first 5 items
const top5 =items.slice(0,5);
const top5Total =top5.map(item => Object.values(item)[0]).reduce((prev, next) => prev + next);
const arrayTotal =Object.values(flatArray).reduce((prev, next) => prev + next);
const others=arrayTotal-top5Total;
const newData = [
  ...top5,
  {
    others: others,

  },
 
]
const data = items.length >5 ? newData : items;
      setAllData(
        data.map((item,index) => {
          return {
            hs_code: Object.keys(item)?.[0],
            value: Object.values(item)?.[0],
            color: colors[index],
          };
        })
      );
    }
  }, [flatArray]);

  useEffect(() => {
    if (allData && allData.length > 0) {
     
      setTableData(
        allData.map((item) => {
          return {
            hs_code: {
              hs_code: item?.hs_code,
              color: item?.color,
            },
            value: `$ ${nFormatter(item?.value)}`,
          };
        })
      );
      setChartData({
        datasets: [
          {
            // label: "My First Dataset",
            data: allData.map((item) => item.value),
            backgroundColor: allData.map((item) => item.color),
            hoverOffset: 0,
            borderWidth: 0,
            
           

          },
        ],
        // labels: allData.map((item) => `${item.hs_code} : ${item.value}`),
       
       
      });
    }
  }, [allData]);



  return (
    <Container>
      <Col span={24}>
        <Row>
          <Title level={4}>{`Distribution by HS Codes`}</Title>
        </Row>
        <Row>
          <Text type="secondary">Since 2021</Text>
        </Row>

        <Row justify="space-between" align="middle">
          <Col span={12} style={{display:'flex',flexDirection:'row',justifyContent:'center',alignContent:"center"}}>
            {chartData && (
              <Doughnut
                data={chartData}
                options={{
                  cutout:130,
                  radius:'80%',
                  legend: {
                    display: false
                  },
                  
                }}
                
               
              />
            )}
          </Col>

          <Col span={12} >
            <Table
              columns={columns}
              dataSource={tableData}
              pagination={false}
            />
          </Col>
        </Row>
      </Col>
    </Container>
  );
}
